// extracted by mini-css-extract-plugin
module.exports = {"sucess_section_circle":"SucessState_sucess_section_circle__DBLb1","sucess_section_icon":"SucessState_sucess_section_icon__NC8SQ"};